"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePartChange = handlePartChange;
const events_1 = require("./events");
async function handlePartChange(event) {
    if (this.ignored === 'true') {
        return;
    }
    const target = event.target;
    let value = null;
    switch (this.constructor.PART_TYPE) {
        case 'input':
            value = target.value;
            if (target.type === 'number' && value) {
                value = Number(value);
            }
            break;
        case 'checkbox':
            // Check if this is a multiple checkbox (returns array) or single (returns boolean)
            if (this.multiple) {
                value = this.value; // Use the component's value for multiple checkboxes
            }
            else {
                value = target.checked;
            }
            break;
        case 'textarea':
            value = target.value;
            break;
        case 'select':
            // Handle multiple select - build array from all selected options
            if (this.multiple) {
                const selectEl = target;
                value = Array.from(selectEl.selectedOptions).map(o => o.value);
            }
            else {
                value = target.value;
                // Try to convert to number if the value represents a number
                if (value && !isNaN(Number(value))) {
                    value = Number(value);
                }
                // Handle null values
                if (value === '' || value === 'null') {
                    value = null;
                }
            }
            break;
        case 'radio':
            value = target.value;
            break;
        case 'file-upload':
            value = this.value;
            break;
        case 'tags':
            value = this.value;
            break;
        case 'switch':
            value = Boolean(this.value);
            break;
        case 'slider':
            value = Number(this.value);
            break;
        case 'date':
            value = target.value;
            break;
        default:
            console.warn(`Unknown part type: ${this.constructor.PART_TYPE}`);
            return;
    }
    if (!this.dontEmit) {
        this.$emit(events_1.inputEvents.changed, {
            fieldName: target.name,
            element: target,
            value,
            htmlEvent: event,
            formPartType: this.constructor.PART_TYPE
        });
        // Also dispatch standard "change" event for broader compatibility
        this.$emit('change', {
            value,
            name: target.name || this.name,
            element: target,
            formPartType: this.constructor.PART_TYPE
        });
    }
    if (this.onChange) {
        await this.onChange(event, value);
    }
}
